import React from 'react';
import {
  AppBar,
  Toolbar,
  Button, // Button 컴포넌트만 필요합니다. IconButton은 더 이상 필요 없습니다.
  Typography,
  Box,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Logout as LogoutIcon,
  Login as LoginIcon
} from '@mui/icons-material';
import logo from '../../assets/images/ksmartech_logo.png';

interface HeaderProps {
  onLogout?: () => void;
  onLogin?: () => void;
  userName?: string;
  isAuthenticated: boolean;
  hideTitle?: boolean; // 모바일/PWA에서 제목 숨김 여부
}

const Header: React.FC<HeaderProps> = ({ onLogout, onLogin, userName, isAuthenticated, hideTitle = false }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: '#f7f9fd',
        color: 'text.primary',
        boxShadow: 'none',
        height: isSmallScreen ? '48px' : '52px'
      }}
    >
      <Toolbar sx={{ minHeight: isSmallScreen ? '48px !important' : '52px !important', px: isSmallScreen ? 1 : 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <img src={logo} alt="Logo" style={{ height: '16px', marginRight: hideTitle ? '0' : '16px' }} />
          {!hideTitle && (
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontSize: '20px',
                fontWeight: 400,
                color: '#3c4043',
                letterSpacing: '-0.25px',
                fontFamily: '"Malgun Gothic", "맑은 고딕", sans-serif'
              }}
            >
              
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isAuthenticated ? (
            // 로그인된 상태: 사용자 이름과 로그아웃 아이콘이 포함된 하나의 버튼
            <Button
              onClick={onLogout}
              color="inherit" // AppBar의 텍스트 색상을 상속
              sx={{
                textTransform: 'none', // 버튼 텍스트 대문자 변환 방지
                color: '#5f6368', // 텍스트와 아이콘 색상
                fontSize: isSmallScreen ? '14px' : '18px',
                fontWeight: 400,
                letterSpacing: '-0.25px',
                fontFamily: '"Malgun Gothic", "맑은 고딕", sans-serif',
                minWidth: 'auto', // Button의 기본 최소 너비 제거
                maxWidth: isSmallScreen ? '58vw' : '420px',
                padding: isSmallScreen ? '4px 8px' : '6px 12px',
                borderRadius: '20px', // 둥근 버튼 모양
                '&:hover': {
                  backgroundColor: '#f1f3f4',
                  boxShadow: 'none',
                },
                boxShadow: 'none', // 기본 그림자 제거
                whiteSpace: 'nowrap', // 텍스트가 줄바꿈되지 않도록
                display: 'flex', // 내부 요소를 flexbox로 정렬
                alignItems: 'center', // 세로 중앙 정렬
                gap: '4px', // 텍스트와 아이콘 사이 간격
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
              // Button의 자식으로 텍스트를 직접 넣고, 아이콘은 endIcon으로
              endIcon={<LogoutIcon sx={{ fontSize: isSmallScreen ? '18px' : '20px' }} />}
            >
              {userName} {/* 사용자 이름을 Button의 직접적인 자식으로 설정 */}
            </Button>
          ) : (
            // 로그인되지 않은 상태: "로그인" 텍스트와 로그인 아이콘이 포함된 하나의 버튼
            <Button
              onClick={onLogin}
              color="inherit"
              sx={{
                textTransform: 'none',
                color: '#5f6368',
                fontSize: isSmallScreen ? '14px' : '18px',
                fontWeight: 400,
                letterSpacing: '-0.25px',
                fontFamily: '"Malgun Gothic", "맑은 고딕", sans-serif',
                minWidth: 'auto',
                padding: isSmallScreen ? '4px 8px' : '6px 12px',
                borderRadius: '20px',
                '&:hover': {
                  backgroundColor: '#f1f3f4',
                  boxShadow: 'none',
                },
                boxShadow: 'none',
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}
              // Button의 자식으로 텍스트를 직접 넣고, 아이콘은 startIcon으로
              startIcon={<LoginIcon sx={{ fontSize: isSmallScreen ? '18px' : '20px' }} />}
            >
              로그인 {/* "로그인" 텍스트를 Button의 직접적인 자식으로 설정 */}
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
